import axios from 'axios';

import type {ProductProps} from '@/molecules/Cards/Product/typings';
import type {ReduxAsyncAction} from './typings';

import constantsFactory from '@/utils/constants';
import paramsHelper from '@/utils/paramsHelper';
import {
  LOAD_FEATURED_ART_REQUEST,
  LOAD_FEATURED_ART_SUCCESS,
  LOAD_FEATURED_ART_FAILURE,
  STATUS_LOADING,
  SEED_FEATURED_ART_SUCCESS,
  SEED_FEATURED_ART_FAILURE,
} from '@/redux/actionTypes';

const {API} = constantsFactory();
const TIMEOUT = 8000;

export interface SuccessApiResponseBody {
  count: number;
  // eslint-disable-next-line camelcase
  num_pages: number;
  results: ProductProps[];
}

interface FeaturedArtParams {
  limit: number;
}

/**
 * @description async thunk action to fetch featured art products
 * @param {{limit:number}} params
 * @return {object} ReduxAsyncAction interface
 */
export const getFeaturedArt: ReduxAsyncAction<FeaturedArtParams, SuccessApiResponseBody> = (
  params,
) => ({
  types: [LOAD_FEATURED_ART_REQUEST, LOAD_FEATURED_ART_SUCCESS, LOAD_FEATURED_ART_FAILURE],
  callAPI() {
    const query = paramsHelper(params).objectToQueryString();

    return axios.get<SuccessApiResponseBody>(
      `${process.env.HOST}${API.PRODUCT_SEARCH_API}${query}`,
      {
        headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        timeout: TIMEOUT,
      },
    );
  },
  shouldCallAPI: (state) => state.featuredArt.status.client !== STATUS_LOADING,
});

export const seedFeaturedArt = (featuredArtProducts: ProductProps[] | null) => ({
  type: !!featuredArtProducts?.length ? SEED_FEATURED_ART_SUCCESS : SEED_FEATURED_ART_FAILURE,
  response: {data: {results: featuredArtProducts}},
});
